/**
 * Russian strings. Единственное место, где живёт текст интерфейса.
 *
 * Ключи именуются по экрану и роли, а не по содержанию, чтобы правка формулировки
 * не заставляла править компоненты.
 */
export const ru = {
  'app.name': 'Chord Trainer',

  'nav.home': 'Главная',
  'nav.training': 'Тренировки',
  'nav.chords': 'Аккорды',
  'nav.progress': 'Прогресс',

  'mic.active': 'Микрофон активен',
  'mic.off': 'Микрофон выключен',
  'mic.checking': 'Проверяем микрофон…',
  'mic.enable': 'Включить микрофон',
  'mic.ready': 'Готово',
  'mic.check': 'Проверка микрофона',
  'mic.invite': 'Включи микрофон — и я буду слышать гитару',
  'mic.inviteHint':
    'Браузер спросит разрешение. Звук разбирается прямо здесь, на устройстве, и никуда не уходит.',
  'mic.denied': 'Нужен доступ к микрофону, чтобы слышать гитару.',
  'mic.deniedHint':
    'Разреши доступ в настройках браузера — без него приложение не сможет проверить аккорд.',
  'mic.unavailable': 'Микрофон не найден или занят другой программой.',
  'mic.unavailableHint': 'Закрой другие вкладки со звонками и попробуй ещё раз.',
  'mic.unsupported': 'Браузер не умеет работать с микрофоном так, как нужно приложению.',
  'mic.unsupportedHint': 'Открой сайт в Chrome, Safari 14.1+ или Firefox по адресу https://',
  'mic.error': 'Что-то пошло не так со звуком.',
  'mic.retry': 'Попробовать снова',
  'mic.quiet': 'Гитару почти не слышно. Подвинь телефон ближе.',
  'mic.noisy': 'Вокруг шумно. Найди место потише — так я расслышу аккорд точнее.',
  'mic.clipping': 'Слишком громко, звук зашкаливает. Отодвинь телефон немного дальше.',
  'mic.privacy': 'Звук разбирается прямо на устройстве и никуда не отправляется.',

  'home.today': 'Сегодняшняя тренировка',
  'home.modes': 'Режимы',
  'home.progress': 'Прогресс',
  'home.start': 'Начать',
  'home.accuracy': 'Точность',
  'home.avgTime': 'Среднее время',
  'home.bestTransition': 'Лучший переход',
  'home.seconds': 'сек',

  'modes.title': 'Тренировки',
  'modes.chordChange': 'Смена аккордов',
  'modes.chordChangeHint': 'Быстрые переходы',
  'modes.cleanChord': 'Чистые аккорды',
  'modes.cleanChordHint': 'Чёткий звук',
  'modes.rhythm': 'Ритм',
  'modes.rhythmHint': 'Играй в такт',
  'modes.strumming': 'Бой',
  'modes.strummingHint': 'Удары вверх и вниз',

  'setup.chords': 'Аккорды',
  'setup.addChord': 'Добавить аккорд',
  'setup.removeChord': 'Убрать {chord}',
  'setup.progression': 'Готовая цепочка',
  'setup.tempo': 'Темп',
  'setup.bpm': '{value} BPM',
  'setup.beatsPerChord': 'Ударов на аккорд',
  'setup.duration': 'Длительность тренировки',
  'setup.durationOption': '{count} мин',
  'setup.start': 'Начать тренировку',
  'setup.needTwoChords': 'Выбери хотя бы два аккорда',
  'setup.tempoDown': 'Медленнее',
  'setup.tempoUp': 'Быстрее',
  'setup.pickChord': 'Выбери аккорд',
  'setup.close': 'Закрыть',
  'setup.pattern': 'Рисунок боя',
  'setup.tuneFirst': 'Сначала настроить гитару →',
  'setup.chord': 'Аккорд',

  'active.playNow': 'Сыграй сейчас',
  'active.next': 'Следующий: {chord}',
  'active.listening': 'Слушаем',
  'active.pause': 'Пауза',
  'active.resume': 'Продолжить',
  'active.repeat': 'Повторить',
  'active.skip': 'Дальше',
  'active.timeShort': '{done}/{total} мин',
  'active.countIn': 'Приготовься',
  'active.paused': 'Пауза',
  'active.finish': 'Завершить',
  'active.exit': 'Выйти из тренировки',

  'verdict.correct': 'Отлично',
  'verdict.almost': 'Почти правильно',
  'verdict.wrong': 'Пока не то',
  'verdict.uncertain': 'Не расслышал',
  'verdict.uncertainHint': 'Сыграй ещё раз чуть громче',

  'feedback.missingNote': 'Не все ноты аккорда слышно',
  'feedback.extraNotes': 'Слышу лишние ноты',
  'feedback.soundsLike': 'Похоже на {chord}',
  'feedback.weakRoot': 'Основной звук аккорда почти не слышен',
  'feedback.unwantedBass': 'Задета лишняя басовая струна',
  'feedback.stringWeak': '{string}-я струна звучит слабо',
  'feedback.stringSilent': '{string}-я струна не звучит',
  'feedback.stringUnwanted': '{string}-я струна лишняя',
  'feedback.stringClear': '{string}-я струна — чисто',
  'feedback.pressHarder': 'Прижимай струны ближе к ладу и сильнее',
  'feedback.avoidTouching': 'Проверь, не задевает ли палец соседнюю струну',

  'clean.title': 'Чистые аккорды',
  'clean.clarity': 'Чистота',
  'clean.whatToFix': 'Что исправить',
  'clean.playAgain': 'Сыграть ещё раз',
  'clean.nextChord': 'Следующий аккорд',
  'clean.playPrompt': 'Сыграй аккорд и держи его',
  'clean.nothingToFix': 'Всё звучит чисто. Так держать.',
  'clean.someStringsUnknown':
    'Часть струн звучит на одних и тех же обертонах — про них я ничего не скажу.',
  'gate.hearingOther': 'Слышу другие звуки. Сыграй на гитаре, когда будешь готов.',
  'gate.hearingNothing': 'Не слышу гитару. Сыграй громче или подвинь телефон ближе.',

  'rhythm.title': 'Ритм',
  'rhythm.instruction': 'Играй один удар вниз на каждую долю',
  'rhythm.score': 'Ритм',
  'rhythm.early': 'Рано',
  'rhythm.onTime': 'Вовремя',
  'rhythm.late': 'Поздно',
  'rhythm.missed': 'Пропуск',
  'rhythm.latencyNote':
    'Задержка микрофона у каждого устройства своя, поэтому я меряю ровность, а не абсолютную точность.',

  'strum.title': 'Бой',
  'strum.instruction': 'Рука двигается всё время вниз-вверх. Бей по струнам там, где стрелка.',
  'strum.directionNote':
    'Направление удара микрофон надёжно не различает — стрелки показывают, как двигать рукой.',

  'tuner.title': 'Тюнер',
  'tuner.entryHint': 'Настрой гитару перед занятием',
  'tuner.prompt': 'Дёргай одну струну и дай ей звучать — тюнер покажет, куда крутить.',
  'tuner.listening': 'Слушаю…',
  'tuner.inTune': 'Чисто',
  'tuner.low': 'Ниже нужного — подтяни колок',
  'tuner.high': 'Выше нужного — ослабь колок',
  'tuner.strings': 'Струны в стандартном строе',

  'chords.title': 'Аккорды',
  'chords.search': 'Найти аккорд',
  'chords.filterBeginner': 'Новичок',
  'chords.filterCommon': 'Частые',
  'chords.filterBarre': 'Баррэ',
  'chords.filterAll': 'Все',
  'chords.empty': 'Ничего не нашлось',
  'chords.emptyHint': 'Попробуй другое название — например, Am или C',
  'chords.startHere': 'Начни с Em, Am, C, G',
  'chords.startHereHint': 'Эти аккорды откроют тебе тысячи песен',
  'chords.practice': 'Тренировать',
  'chords.strings': 'Струны',
  'chords.difficulty': 'Сложность',
  'chords.notPlayed': 'не играется',
  'chords.open': 'открытая',
  'chords.fret': '{fret} лад',
  'chords.finger': '{finger}-й палец',
  'chords.barre': 'Баррэ на {fret} ладу',
  'chords.easierVariant': 'Полегче: {chord}',

  'progress.title': 'Прогресс',
  'progress.week': 'Неделя',
  'progress.month': 'Месяц',
  'progress.all': 'Всё время',
  'progress.focus': 'Сейчас работаем над',
  'progress.tempoGrowth': 'Рост темпа',
  'progress.weakTransitions': 'Слабые переходы',
  'progress.strongTransitions': 'Лучшие переходы',
  'progress.accuracy': 'Точность',
  'progress.avgTime': 'Среднее время',
  'progress.goal': 'цель {value} BPM',
  'progress.empty': 'Здесь появится статистика',
  'progress.emptyHint': 'Проведи первую тренировку — и я покажу, что растёт',
  'progress.noTransitions': 'Пока нечего показать',

  'session.done': 'Тренировка завершена',
  'session.praise': 'Отличная работа!',
  'session.praiseGood': 'Хороший результат',
  'session.praiseKeep': 'Главное — регулярность',
  'session.time': 'Время',
  'session.transitions': 'Переходов',
  'session.accuracy': 'Точность',
  'session.rhythm': 'Ритм',
  'session.clarity': 'Чистота',
  'session.best': 'Лучший переход',
  'session.practiceNext': 'Потренировать',
  'session.nextSession': 'Следующая тренировка:',
  'session.repeat': 'Повторить',
  'session.continue': 'Продолжить',

  'reason.weakTransition': 'Этот переход даётся тяжелее остальных',
  'reason.lowClarity': 'Аккорд звучит нечисто',
  'reason.weakRhythm': 'Стоит поработать над ровностью',
  'reason.spacedReview': 'Давно не повторяли',
  'reason.firstSession': 'С этого удобно начать',

  'error.title': 'Что-то сломалось на этом экране',
  'error.hint': 'Данные о занятиях сохранены. Вернись на главную и продолжай.',
  'error.restart': 'На главную',

  'settings.title': 'Настройки',
  'settings.open': 'Настройки',
  'settings.sound': 'Щелчок метронома',
  'settings.adaptive': 'Подстраивать темп',
  'settings.adaptiveHint': 'Приложение немного ускоряется, когда получается, и замедляется, когда нет',
  'settings.reset': 'Стереть прогресс',
  'settings.resetHint': 'Удалит историю занятий и статистику с этого устройства. Отменить нельзя.',
  'settings.resetConfirm': 'Точно стереть?',
  'settings.resetDone': 'Прогресс стёрт',
  'settings.cancel': 'Отмена',
  'settings.privacy': 'Звук разбирается на устройстве. Записи не сохраняются и никуда не отправляются.',

  'common.back': 'Назад',
  'common.seconds': 'сек',
} as const;

export type TranslationKey = keyof typeof ru;
